import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Ticket
export const createTicket = createAsyncThunk(
  'ticket/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/tickets', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create ticket');
    }
  }
);

// Fetch Ticket by ID
export const fetchTicketById = createAsyncThunk(
  'ticket/fetchById',
  async (ticketId: string, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/tickets/${ticketId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ticket');
    }
  }
);

// Fetch All Tickets
export const fetchAllTickets = createAsyncThunk(
  'ticket/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/tickets');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tickets');
    }
  }
);

export const fetchTicketSummary = createAsyncThunk(
  'ticket/fetchTicketSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/tickets-summary');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Ticket Category');
    }
  }
);

// Update Ticket
export const updateTicket = createAsyncThunk(
  'ticket/update',
  async ({ ticketId, ...data }: any & { ticketId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/tickets/${ticketId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update ticket');
    }
  }
);

// Delete Ticket
export const deleteTicket = createAsyncThunk(
  'ticket/delete',
  async (ticketId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/tickets/${ticketId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete ticket');
    }
  }
);

// Fetch Tickets by Department
export const fetchTicketsByDepartment = createAsyncThunk(
  'ticket/fetchByDepartment',
  async (departmentId: string, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/tickets/department/${departmentId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tickets by department');
    }
  }
);

export const fetchTicketsSummaryByDepartment = createAsyncThunk(
  'ticket/fetchTicketsSummaryByDepartment',
  async (departmentId: string, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/tickets-summary/department/${departmentId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tickets by department');
    }
  }
);

// Fetch Tickets by Employee Hierarchy
export const fetchTicketsByEmployeeHierarchy = createAsyncThunk(
  'ticket/fetchByEmployeeHierarchy',
  async ({ employeeId, departmentId }: { employeeId: string; departmentId: string }, { rejectWithValue }) => {
    try {
      // Pass both employeeId and departmentId as query params
      const response = await employeeServiceApiInstance.get(`/tickets/hierarchy/${employeeId}`, {
        params: { departmentId } // This will be appended to the URL as a query parameter
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tickets by hierarchy');
    }
  }
);



